module.exports = __webpack_public_path__ + "img/sun-protect-body.d59b65d0.png";